// Client calls for the root-admin console. Each returns a Promise(Either)
// (Left = error string, Right = payload), matching the rest of the app's
// fetch layer. postJSONPS prefixes /api and sends the session cookie.
import { composePS } from '@cd/pipe';
import { postJSONPS } from '../lib/utils/fetch';

const post = (url, body) =>
	composePS(postJSONPS)('POST', url, { body: JSON.stringify(body || {}) });

// First factor: email + password. Right('CODE_SENT') on success.
export const postAdminLogin = (email, pwd, version) =>
	post('/admin/login', { email, pwd, version });

// Second factor: the emailed code. Right('OK') on success.
export const postAdminVerify = code => post('/admin/verify', { code });

// Find member accounts by sign-in email. Right([{ id, memberID, ... }]).
export const postAdminLookup = email => post('/admin/members/lookup', { email });

// Impersonate the account with mp_users_web.id === userId. Right('OK').
export const postAdminImpersonate = userId =>
	post('/admin/impersonate', { userId });

// Stop impersonating, restore the admin identity. Right('OK').
export const postAdminExitImpersonation = () =>
	post('/admin/exit-impersonation', {});

// Current console state: { isAdmin, impersonating, impersonatedBy, currentUser }.
export const postAdminSession = () => post('/admin/session', {});

// Admin sign-out (clears the session).
export const postAdminLogout = () => post('/admin/logout', {});
